import { useEffect } from "react";
import "@/App.css";
import LocatorWidget from "./components/LocatorWidget";

function App() {
  // Remove Emergent badge for clean iframe embed
  useEffect(() => {
    const badge = document.getElementById('emergent-badge');
    if (badge) {
      badge.remove();
    }
  }, []);

  return (
    <div className="App">
      <LocatorWidget />
    </div>
  );
}

export default App;
